module.exports = __webpack_public_path__ + "img/responsive hospitium-04.57dec08b.jpg";